module.exports = __webpack_public_path__ + "img/pcn-staff-icon.0f8ac8ac.svg";